<template>
	<div>
		<BusinessBanner />
		<div class="content-zsy" v-loading="loading" style="min-height: 400px;">
			<InventoryNavi />
			<div class="widget-location">
				<h3>발송현황</h3>
			</div>
			
			<div class="search-card">
				<div class="search-form-inline">
					<div class="form-item-group">
						<span class="form-item-label">선택검색</span>
						<el-select v-model="s" placeholder="" style="width: 110px; margin-right: 6px;">
						    <el-option
						      v-for="item in s_options"
						      :key="item.value"
						      :label="item.label"
						      :value="item.value">
						    </el-option>
						</el-select>
						<el-input v-model="k" placeholder="검색어" class="form-item-input" style="width: 140px !important;" clearable></el-input>
					</div>
					
					<div class="form-item-group">
						<span class="form-item-label">상태선택</span>
						<el-select v-model="status" placeholder="선택하세요" style="width: 140px;">
						    <el-option
						      v-for="item in options"
						      :key="item.value"
						      :label="item.name"
						      :value="item.value">
						    </el-option>
						</el-select>
					</div>
					
					<div class="form-item-group">
						<span class="form-item-label">등록일</span>
						<el-date-picker type="date" v-model="date1" placeholder="시작일" style="width: 135px;"></el-date-picker>
						<span style="margin: 0 4px; color: #94a3b8;">~</span>
						<el-date-picker type="date" v-model="date2" placeholder="종료일" style="width: 135px;"></el-date-picker>
					</div>
					
					<div class="form-action-group">
						<el-button type="primary" icon="el-icon-search" @click="changeSearch">검색</el-button>
						<el-button icon="el-icon-refresh" @click="onReset">검색 초기화</el-button>
					</div>
				</div>
			</div>
			
			<div class="table-list" v-if="!isMobile">
				<div class="page-info">
					<span>전체 : <strong>{{total}}</strong> ({{current_page}}/{{last_page}} 페이지)</span>
				</div>
				<el-table
				    :data="tableData"
				    stripe empty-text="데이타가 없습니다."
				    style="width: 100%">
					<el-table-column
						label="상태"
						width="120">
						<template slot-scope="scope">
							  <div style="display: flex; justify-content: center;">
								  {{scope.row.status_name}}
							  </div>							
						</template>
					</el-table-column>
				    <el-table-column
				      label="상품정보">
						<template slot-scope="scope">
							<div><a class="scope-a" :href="scope.row.url" target="_blank">{{ scope.row.goods_name }}</a></div>
						</template>
				    </el-table-column>
					<el-table-column label="발송 상세 정보" min-width="320">
					  <template slot-scope="scope">
						<div class="agency-info-row">
						  <!-- 1. 상품코드 -->
						  <div class="info-badge">
							<span class="badge-label">상품코드</span>
							<span class="badge-value">{{ scope.row.code || '-' }}</span>
						  </div>
						  <!-- 2. 배송센터 -->
						  <div class="info-badge">
							<span class="badge-label">배송센터</span>
							<span class="badge-value">해상</span>
						  </div>
						  <!-- 3. 단가 (CNY) -->
						  <div class="info-badge" v-if="scope.row.price">
							<span class="badge-label">단가</span>
							<span class="badge-value" style="color: #ff5700; font-weight: bold;">{{ scope.row.price }} CNY</span>
						  </div>
						  <!-- 4. 색상 -->
						  <div class="info-badge" v-if="scope.row.color">
							<span class="badge-label">색상</span>
							<span class="badge-value">{{ scope.row.color }}</span>
						  </div>
						  <!-- 5. 사이즈 -->
						  <div class="info-badge" v-if="scope.row.size">
							<span class="badge-label">사이즈</span>
							<span class="badge-value">{{ scope.row.size }}</span>
						  </div>
						  <!-- 6. 발송수량 -->
						  <div class="info-badge">
							<span class="badge-label">발송수량</span>
							<span class="badge-value" style="font-weight: bold; color: #409eff;">{{ scope.row.num }}</span>
						  </div>
						  <!-- 7. 수취인명 -->
						  <div class="info-badge">
							<span class="badge-label">수취인명</span>
							<span class="badge-value" style="color: #0066ff;">{{ scope.row.realname || '-' }}</span>
						  </div>
						  <!-- 8. 송장번호 -->
						  <div class="info-badge">
							<span class="badge-label">송장번호</span>
							<span class="badge-value">-</span>
						  </div>
						  <!-- 9. 등록일 -->
						  <div class="info-badge">
							<span class="badge-label">등록일</span>
							<span class="badge-value">{{ scope.row.createtime_format }}</span>
						  </div>
						  <!-- 10. 발송일 -->
						  <div class="info-badge">
							<span class="badge-label">발송일</span>
							<span class="badge-value">{{ scope.row.status >= 26 ? scope.row.dispatchtime : '-' }}</span>
						  </div>
						</div>
					  </template>
					</el-table-column>
					 <el-table-column label="메뉴" width="240">
					    <template slot-scope="scope">
							<div style="display: flex; flex-wrap: wrap; gap: 6px; align-items: center;">
								<el-button
								  size="mini"
								  type="danger" plain
								  @click="handleDelete(scope.$index, scope.row)">삭제</el-button>
							</div>
					    </template>
					</el-table-column>
				  </el-table>
				<div class="block">
				  <el-pagination
				    layout="prev, pager, next"  :page-size="20"
				    :total="total"  @current-change="handleCurrentChange" >
				  </el-pagination>
				</div>
			</div>
			<div v-else class="table-list">
				<div class="page-info">
					<span>전체 : <strong>{{total}}</strong> ({{current_page}}/{{last_page}} 페이지)</span>
				</div>
				
				<div class="info-wrap" v-for="(item,index) in tableData" :key="index" >
					<div class="item-info-wrap">
						<div class="item-status">
							상태: <span>{{item.status_name}}</span>
						</div>
						<div class="info-right-top">
							<span class="item-center">[해상]</span>
							<span class="item-code">상품코드 : {{item.code}}</span>
						</div>
						<div class="info-right-bottom">
							<div class="item-goodsname">
								<a :href="item.url" target="_blank">{{item.goods_name}}</a>
							</div>
						</div>
					</div>
					<div class="item-option-wrap">
						단가: <span class="item-option item-option-price">{{item.price}} CNY</span>, 색상: <span class="item-option item-option-color">{{item.color}}</span>, 사이즈: <span class="item-option item-option-size">{{item.size}}</span>
					</div>
					
					<div class="item-quantity-wrap">
						<div class="item-quantity">
							<div>수취인명 : <span class="color-blue">{{ item.realname }}</span></div>
							<div>송장번호 : -</div>
				
						</div>
					</div>
					<div class="item-date-wrap">
						등록일 : {{ item.createtime_format }} /
						발송일 : {{item.status>=26?item.dispatchtime:"-"}}                        
					</div>
					
					<div style="display: flex;justify-content: space-between;">
						<!-- <el-button size="mini" plain @click="handleTrackingno(index, item)" >트래킹넘버 입력</el-button> -->
	<!-- 					<el-button
						  size="mini"  type="primary" plain
						  @click="handleEdit(index, item)">확인</el-button> -->
						<el-button
						  size="mini"
						  type="danger" plain
						  @click="handleDelete(index, item)">삭제</el-button>
					</div>		
				</div>
			</div>
			
			<!-- <el-dialog title="상세정보" :visible.sync="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false" :width="isMobile?'98%':'1100px'">
					<el-row>
						<el-col :xs="5" :sm="2" class="table-title" >배송센터</el-col>
						<el-col :xs="7" :sm="4" class="table-content">
							<div style="display: flex;flex-direction: column;">
								<div>해상</div>
								<div class="label-warehouse">재고입고</div>
							</div>
						</el-col>
						<el-col :xs="5" :sm="2" class="table-title">아이템번호</el-col>
						<el-col :xs="7" :sm="4" class="table-content">123456<br>(신청접수)</el-col>			
						<el-col :xs="5" :sm="2" class="table-title" >신청서번호</el-col>
						<el-col :xs="7" :sm="4" class="table-content" >-</el-col>
						<el-col :xs="5" :sm="2" class="table-title">등록일</el-col>
						<el-col :xs="7" :sm="4" class="table-content">{{info.createtime}}</el-col>
						
						<el-col :xs="5" :sm="2" class="table-title" >상품명</el-col>
						<el-col :xs="7" :sm="4" class="table-content" >{{info.goods_name}}</el-col>
						<el-col :xs="5" :sm="2" class="table-title">품목분류</el-col>
						<el-col :xs="7" :sm="4" class="table-content">{{info.category}}</el-col>			
						<el-col :xs="5" :sm="2" class="table-title" >관리코드</el-col>
						<el-col :xs="7" :sm="4" class="table-content" >{{info.refer_code}}</el-col>
						<el-col :xs="5" :sm="2" class="table-title">창고도착일</el-col>
						<el-col :xs="7" :sm="4" class="table-content">-</el-col>
						
						<el-col :xs="5" :sm="2" class="table-title" >색상</el-col>
						<el-col :xs="7" :sm="4" class="table-content" >{{info.color}}</el-col>
						<el-col :xs="5" :sm="2" class="table-title">사이즈</el-col>
						<el-col :xs="7" :sm="4" class="table-content">{{info.size}}</el-col>			
						<el-col :xs="5" :sm="2" class="table-title" >재고상품코드</el-col>
						<el-col :xs="7" :sm="4" class="table-content" >{{info.code}}</el-col>
						<el-col :xs="5" :sm="2" class="table-title">입고완료일</el-col>
						<el-col :xs="7" :sm="4" class="table-content">-</el-col>
						
						<el-col :xs="5" :sm="2" class="table-title" >단가</el-col>
						<el-col :xs="7" :sm="4" class="table-content" >{{info.price}} CNY</el-col>
						<el-col :xs="5" :sm="2" class="table-title">주문수량</el-col>
						<el-col :xs="7" :sm="4" class="table-content">{{info.apply_quantity}}</el-col>			
						<el-col :xs="5" :sm="2" class="table-title" >입고수량</el-col>
						<el-col :xs="7" :sm="4" class="table-content" >-</el-col>
						<el-col :xs="5" :sm="2" class="table-title">결제완료일</el-col>
						<el-col :xs="7" :sm="4" class="table-content">-</el-col>
						
						<el-col :xs="5" :sm="2" class="table-title" >오더넘버</el-col>
						<el-col :xs="7" :sm="4" class="table-content" >{{info.order_no}}</el-col>
						<el-col :xs="5" :sm="2" class="table-title">트래킹넘버</el-col>
						<el-col :xs="7" :sm="4" class="table-content">{{info.tracking_no}}</el-col>			
						<el-col :xs="5" :sm="2" class="table-title" >쉬핑네임</el-col>
						<el-col :xs="7" :sm="4" class="table-content" >{{info.ship_name}}</el-col>
						<el-col :xs="5" :sm="2" class="table-title">발송완료일</el-col>
						<el-col :xs="7" :sm="4" class="table-content">-</el-col>
						
						<el-col :xs="5" :sm="2" class="table-title" >상품 관리번호</el-col>
						<el-col :xs="7" :sm="4" class="table-content">-</el-col>
						<el-col :xs="5" :sm="2" class="table-title">포장 박스수량</el-col>
						<el-col :xs="7" :sm="4" class="table-content">-</el-col>			
						<el-col :xs="5" :sm="2" class="table-title" >국내 쇼핑몰</el-col>
						<el-col :xs="7" :sm="4" class="table-content" >-</el-col>
						<el-col :xs="5" :sm="2" class="table-title">배송완료일</el-col>
						<el-col :xs="7" :sm="4" class="table-content">-</el-col>
						
						<el-col :xs="5" :sm="2" class="table-title" >URL</el-col>
						<el-col :xs="19" :sm="10" class="table-content">
							<a :href="info.url" target="_blank">{{info.url}}</a>
						</el-col>
						<el-col :xs="5" :sm="2" class="table-title">입고 요청메세지</el-col>
						<el-col :xs="19" :sm="10" class="table-content">{{info.shipping_memo}}</el-col>			
			
					</el-row>
			</el-dialog> -->
			
		</div>
	
	</div>
</template>

<script>
	import BusinessBanner from '../../components/BusinessBanner.vue'
	import InventoryNavi from '../../components/InventoryNavi.vue'
	import request from '@/utils/request'
	export default {
		components: {
			BusinessBanner,
			InventoryNavi
		},
		data() {
			return{
				loading: true,
				s_options: [{
				  value: 'code',
				  label: '상품코드'
				}, {
				  value: 'barcode',
				  label: '바코드'
				}, 
				{
				  value: 'refer_code',
				  label: '관리코드'
				}, 
				// {
				//   value: 'delivery_number',
				//   label: '송장번호'
				// }, 
				{
				  value: 'realname',
				  label: '수취인명'
				}, 
				
				{
				  value: 'hp',
				  label: '연락처'
				},
				{
				  value: 'platform_order_no',
				  label: '플랫폼주문번호'
				},
				],
				s: 'code',
				k:"",
				options:[],
				status:"",
				date1:"",
				date2:"",
				
				total:0,
				current_page:1,
				last_page:1,
				page:1,
				tableData: [],
				//dialogFormVisible: false,
				//info:{},
				
			}
		},
		computed: {
			isMobile() {
			  return window.innerWidth <= 768;
			}
		},
		created(){
			this.getList()
			this.getGoodsStatus()
		},
		methods: {
			getGoodsStatus(){
				request.post('/member/Inventory/getGoodsStatus',{
					type:2
				})
				.then(res => {
					console.log(res,"status")
					if(res.code ==1){
						this.options= res.data
					}
						
				});
			},
			getList(){
				this.loading = true
				console.log("获取列表")
				request.post('/member/Inventory/getInventoryPacking',{
					page:this.page,
					s:this.s,
					k:this.k,
					status:this.status,	
					date1:this.date1,
					date2:this.date2,
				})
				.then(res => {
					this.loading = false
					console.log(res,"212")
					if(res.code ==1){
						this.total = res.data.total
						this.current_page = res.data.current_page
						this.last_page = res.data.last_page
						this.tableData= res.data.data
					}
						
				}).catch(() => {
					this.loading = false
				});
			},
			handleCurrentChange(val) {
			    console.log(`当前页: ${val}`);
				this.page = val
				this.getList()
			},
			changeSearch(){
				this.page = 1
				this.getList()	
			},
			onReset(){
				this.s='code'
				this.k=''
				this.status=""
				this.date1=""
				this.date2=""
				
				this.page = 1
				this.getList()
			},
			// getGoodsInfo(id){
			// 	console.log(id,2222)
			// 	request.post('/member/Inventory/getGoodsInfo',{
			// 		id:id
			// 	})
			// 	.then(res => {
			// 		if(res.code ==1){
			// 			console.log(res.data,"详细信息")
			// 			this.info = res.data
			// 		}		
			// 	});
			// },
			// handleEdit(index, row) {
			// 	console.log(index, row);
			// 	this.dialogFormVisible = true
			// 	this.getGoodsInfo(row.id)
			// },
			handleDelete(index, row) {
				console.log(index, row);
				console.log(row.id)
				this.$confirm('정말 삭제하겠습니까?', '', {
				  confirmButtonText: '확인',
				  cancelButtonText: '취소',
				  type: 'warning'
				}).then(() => {
					request.post('/member/Inventory/deleteInventoryPacking',{
						id:row.id
					})
					.then(res => {
						console.log(res,"")
						if(res.code ==1){
							this.$message({
								type: 'success',
								message: '삭제 성공!'
							});
							this.page = 1
							this.getList()
						}		
					});
					
				}).catch(() => {     
				});
				
			}
			
		}
		
	}
	
</script>

<style scoped>
	.widget-location {
	    margin-top: 50px;
	    margin-bottom: 60px;
	    text-align: center;
	}
	.widget-location h3 {
	    padding: 0;
	    margin: 0;
	    font-size: 45px;
	    font-weight: bold;
	    color: var(--frontground-color);
	}
	.condition-wrap{
		padding: 0 20px;	
	}
	.condition-wrap .unit{
		font-weight: bold;
		width:100px;
		padding: 10px 0;
	}
	
	.table-list{
		margin:30px 0;
	}
	.table-list .page-info{
		font-size: 16px;
		font-weight: bold;
		padding:0 30px 20px;
	}
	.table-list .page-info strong{
		font-weight: normal;
		color: var(--main-color);
	}
	.table-list .block{
		padding-top: 20px;
		text-align: center;
	}
	.table-title{
		background-color: #f5f8fd;border-top: 1px solid #e3e3e3;border-bottom: 1px solid #e3e3e3;font-size: 15px;min-height: 75px;display: flex;justify-content: center;align-items: center;
	}
	.table-content{
		border: 1px solid #e3e3e3;font-size: 14px;height: 75px;padding:0 10px;display: flex;align-items: center;overflow: hidden;
	}
	.table-content a{
		text-decoration: none;
		color: #337ab7;
	}
	
	.color-blue {
	    color: #0066ff !important;
	}
	::v-deep .el-table th.el-table__cell {
		text-align: center;
		color:#333;
	}
	.scope-a{
		color: #333;font-weight: 500;text-decoration: none;
	}
	/* 分页背景 */
	::v-deep .el-pager li {
		background-color: #121212;
	}
	::v-deep .el-pagination button:disabled {
		background-color: #121212;
	}
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.s_margin{
			margin:  15px 0;;
		}
		.widget-location h3 {
		    font-size: 30px;
		    font-weight: bold;
		    margin: 0;
		    word-break: keep-all;
		}
		/* 列表 */
		.info-wrap{
			border-top: 2px solid var(--border-color);
			margin:10px 20px;
		}
		.item-info-wrap{
			padding:10px 0;
		}
		.item-info-wrap .item-status {
		    margin-bottom: 1px;
		    font-weight: 600;
		    font-size: 13px;
		    line-height: 20px;
		}
		.item-info-wrap .item-status span {
		    font-weight: normal;
		}
		.item-info-wrap .item-center {
		    font-weight: bold;
		    font-size: 13px;
		    color: #666;
		}
		.item-info-wrap .item-code {
		    color: var(--main-color);
		    font-size: 13px;
		}
		.item-info-wrap .item-goodsname {
		    color: #333;
		    font-size: 13px;
		    line-height: 18px;
		    letter-spacing: -0.01em;
		    font-weight: bold;
		    margin-top: 5px;
		}
		.item-info-wrap .item-goodsname a {
		    color: #333;
			text-decoration: none;
		}
		.item-option-wrap {
			color:#333;
		    padding: 7px 10px 6px;
		    background: #f4f4f4;
		    font-size: 12px;
		    line-height: 19px;
		    letter-spacing: -0.01em;
		}
		.item-quantity-wrap {
			color:#333;
		    display: flex;
		    margin: 10px 0 10px;
		}
		.item-quantity-wrap .item-quantity {
		    flex: 1;
		    align-self: center;
		    background-color: #eff3f9;
		    padding: 7px 10px 6px;
		    display: flex;
		    gap: 5px;
		    justify-content: space-between;
		    flex-wrap: wrap;
		    font-size: 12px;
		}
		.info-wrap .item-date-wrap {
		    font-size: 13px;
		    line-height: 18px;
		    letter-spacing: -0.01em;
		    margin-bottom: 11px;
		}
	
	}
	.agency-info-row {
	    display: flex;
	    flex-wrap: wrap;
	    gap: 8px;
	    align-items: center;
	    padding: 4px 0;
	}
	.info-badge {
	    display: inline-flex;
	    align-items: center;
	    border: 1px solid #dcdfe6;
	    border-radius: 6px;
	    overflow: hidden;
	    font-size: 12px;
	    background: #fff;
	    line-height: 1.4;
	    box-shadow: 0 1px 2px rgba(0,0,0,0.02);
	}
	.badge-label {
	    background: #f5f7fa;
	    color: #606266;
	    padding: 5px 10px;
	    border-right: 1px solid #dcdfe6;
	    font-weight: bold;
	    white-space: nowrap;
	}
	.badge-value {
	    padding: 5px 12px;
	    color: #303133;
	    white-space: nowrap;
	}
	.search-card {
		background: #f8fafc;
		border: 1px solid #e2e8f0;
		border-radius: 12px;
		padding: 16px 20px;
		margin-bottom: 24px;
		box-shadow: 0 1px 3px rgba(0,0,0,0.02);
	}
	.search-form-inline {
		display: flex;
		flex-wrap: wrap;
		gap: 16px;
		align-items: center;
	}
	.form-item-group {
		display: inline-flex;
		align-items: center;
		gap: 8px;
	}
	.form-item-label {
		font-size: 13px;
		font-weight: 600;
		color: #475569;
		white-space: nowrap;
		min-width: 60px;
		text-align: right;
	}
	.form-item-input {
		width: 180px !important;
	}
	.form-action-group {
		display: inline-flex;
		align-items: center;
		gap: 10px;
		margin-left: auto;
	}
	@media (max-width: 768px) {
		.form-action-group {
			margin-left: 0;
			width: 100%;
			justify-content: flex-end;
		}
		.form-item-input {
			width: 100% !important;
		}
		.form-item-group {
			width: 100%;
		}
	}
</style>